(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('WhatsAppWebService', WhatsAppWebService);

  WhatsAppWebService.$inject = ['$resource'];

	 function WhatsAppWebService ($resource) {
    return $resource(apiUrl + '/web-channels/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      find: { method: 'GET', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: true },
      user: { url: apiUrl + '/user-web-channels', method: 'GET', params: {}, isArray: true },
      createActiveWhatsapp: { url: apiUrl + '/create-active-whatsapp/:id', method: 'POST', params: {}, isArray: false }
    });
  }
})();
